module.exports = __webpack_public_path__ + "img/2.d7c71001.jpg";